type ChallengeRatingCharacter = {
    challenge?: number;
    hostile?: boolean;
};

export interface CharacterColorMap {
    bg: string
    text: string
    border: string
    hex: string

}

export const CR_COLOR_MAP: Record<string, CharacterColorMap> = {
    unknown: {
        bg: "bg-cyan-500/20",
        text: "text-cyan-400",
        border: "border-cyan-500",
        hex: "oklch(71.5% 0.143 215.221)"
    },
    friendly: {
        bg: "bg-emerald-500/20",
        text: "text-emerald-400",
        border: "border-emerald-500",
        hex: "oklch(69.6% 0.17 162.48)"
    },
    // CR 0 - 1: Harmlos / Kleinvieh
    harmless: {
        bg: "bg-amber-500/20",
        text: "text-amber-400",
        border: "border-amber-500",
        hex: "oklch(76.9% 0.188 70.08)"
    },
    // CR 2 - 4: Ernsthafte Gegner
    moderate: {
        bg: "bg-orange-500/20",
        text: "text-orange-400",
        border: "border-orange-500",
        hex: "oklch(70.5% 0.213 47.604)"
    },
    // CR 5 - 10: Gefährlich
    dangerous: {
        bg: "bg-red-500/20",
        text: "text-red-400",
        border: "border-red-500",
        hex: "oklch(63.7% 0.237 25.331)"
    },
    // CR 11 - 16: Sehr Gefährlich
    deadly: {
        bg: "bg-rose-500/20",
        text: "text-rose-400",
        border: "border-rose-500",
        hex: "oklch(64.5% 0.246 16.439)"
    },
    // CR 17 - 20: Legendär
    legendary: {
        bg: "bg-pink-500/20",
        text: "text-pink-400",
        border: "border-pink-500",
        hex: "oklch(65.6% 0.241 354.308)"
    },
    // CR 21+: Mythisch / Göttergleich
    mythic: {
        bg: "bg-purple-500/20",
        text: "text-purple-400",
        border: "border-purple-500",
        hex: "oklch(62.7% 0.265 303.9)"
    },
};


export const formatChallengeRating = (character: ChallengeRatingCharacter): string => {
    if (character.challenge === undefined) return "";
    if (character.challenge === 0 || character.challenge >= 1) return character.challenge + "";
    return "1/" + 1 / character.challenge;
}

export const getStyleColor = (character: ChallengeRatingCharacter): CharacterColorMap => {
    if (!character.hostile) return CR_COLOR_MAP["friendly"];
    if (!character.challenge) return CR_COLOR_MAP["unknown"];
    const cr = character.challenge;

    if (cr <= 1) return CR_COLOR_MAP["harmless"];
    if (cr <= 4) return CR_COLOR_MAP["moderate"];
    if (cr <= 10) return CR_COLOR_MAP["dangerous"];
    if (cr <= 16) return CR_COLOR_MAP["deadly"];
    if (cr <= 20) return CR_COLOR_MAP["legendary"];
    return CR_COLOR_MAP["mythic"];
};
